module.exports = __webpack_public_path__ + "img/4.5ec63d76.png";